import { JsonItem, ListItem, ListInformation, PickListItem, PickListItemSorted } from "./list-management.objects";
import { plainToClass } from "class-transformer";

declare var $: any;
export class PickListController {
    id: string;
    getHandler: string;
    getSortedHandler: string;
    postHandler: string;
    postSortedHandler: string;
    pickLists: JsonItem[];
    sortedPickLists: JsonItem[];

    currentPickListName: string;
    currentOptionsList: PickListItem[];
    currentSortedOptionsList: PickListItemSorted[];
    currentOptionId: number;
    currentOptionValue: string;
    currentSortOrder: number;
    currentGroup: string;
    isCurrentSortList: boolean = false;

    sectionContainer: JQuery<HTMLElement>; 
    pickListGroupDropdown: JQuery<HTMLElement>;
    allPickListsDropdown: JQuery<HTMLElement>; 
    selectedListTitle: JQuery<HTMLElement>; 
    selectedListOptionDropdown: JQuery<HTMLElement>; 
    buttonContainer: JQuery<HTMLElement>;
    addNewOptionBtn: JQuery<HTMLElement>; 
    editOptionBtn: JQuery<HTMLElement>; 

    pickListOptionsTableContainer: JQuery<HTMLElement>;
    pickListOptionsTable: JQuery<HTMLElement>; 

    pickListModal: JQuery<HTMLElement>;
    pickListModalTitle: JQuery<HTMLElement>;
    pickListFormSection: JQuery<HTMLElement>;
    currentPickListUpdate: PickListUpdate;
    currentSortedPickListUpdate: PickListSortedUpdate;

    pickListNameMap: Map<string, string> = new Map();
    pickListGroupMap: PickListGroup[] = [];

    constructor(id: string, getHandler: string, postHandler: string, getSortedHandler: string = "", postSortedHandler: string = "") {
        this.id = id;
        this.getHandler = getHandler;
        this.postHandler = postHandler;
        this.getSortedHandler = getSortedHandler;
        this.postSortedHandler = postSortedHandler;

        // General
        this.pickListNameMap.set("RevamppVersion", "ReVAMPP Versions");
        this.pickListNameMap.set("RevamppStatus", "ReVAMPP Statuses");
        this.pickListNameMap.set("YesNo", "Yes/No Selection");

        // Center, Core, Project
        this.pickListNameMap.set("CoreServices", "Core Services");
        this.pickListNameMap.set("VaccinePlatforms", "Vaccine Platform Approaches");
        this.pickListNameMap.set("AntibodyPlatforms", "Antibody Platform Approaches");
        this.pickListNameMap.set("Countermeasures", "Countermeasures");
        this.pickListNameMap.set("OrganizationalType", "Organizational Types");

        // Location
        this.pickListNameMap.set("CountryRegion", "WHO Country Regions");
        this.pickListNameMap.set("UsStates", "US States");

        // Users
        this.pickListNameMap.set("MemberRoles", "Affiliation Roles");
        this.pickListNameMap.set("TerminalDegree", "Terminal Degrees");
        this.pickListNameMap.set("GroupCommittee", "Groups/Committees");
        this.pickListNameMap.set("GroupCommitteeRoles", "Group/Committee Roles");
        this.pickListNameMap.set("OrgInstitution", "Organization/Institution Names");

        // Virus
        this.pickListNameMap.set("BSL", "BSL");
        this.pickListNameMap.set("ABSL", "ABSL");
        this.pickListNameMap.set("VirusVector", "Virus Vectors");
        this.pickListNameMap.set("VirusHost", "Virus Disease Hosts");
        this.pickListNameMap.set("VirusOrder", "Virus Orders");
        this.pickListNameMap.set("AnimalModel", "Type of Animal Models");
        this.pickListNameMap.set("VirusTarget", "Virus Target");

        // Deliverables
        this.pickListNameMap.set("DeliverableCategory", "Deliverable Category");
        this.pickListNameMap.set("TrlTag", "Technology Readiness Level (TRL)");
        this.pickListNameMap.set("DeliverableSubcategoryVaccine", "Deliverable Subcategory - Vaccine");
        this.pickListNameMap.set("DeliverableSubcategoryAntibody", "Deliverable Subcategory - Antibody");
        this.pickListNameMap.set("DeliverableSubcategoryKnowledge", "Deliverable Subcategory - Generalizable Knowledge");
        this.pickListNameMap.set("DeliverableSubcategoryCoordination", "Deliverable Subcategory - Coordination & Sharing");
        this.pickListNameMap.set("DeliverableStageVaccine", "Deliverable Stage - Vaccine");
        this.pickListNameMap.set("DeliverableStageAntibody", "Deliverable Stage - Antibody");
        this.pickListNameMap.set("DeliverableStageKnowledge", "Deliverable Stage - Generalizable Knowledge");
        this.pickListNameMap.set("DeliverableStageCoordination", "Deliverable Stage - Coordination & Sharing");

        // Animal Models
        this.pickListNameMap.set("AM_Purpose", "AM Model Purpose");
        this.pickListNameMap.set("AM_Route", "AM Virus Route");
        this.pickListNameMap.set("AM_Species", "AM Animal Species");
        this.pickListNameMap.set("AM_Strain", "AM Animal Strain");
        this.pickListNameMap.set("AM_Source", "AM Animal Source");
        this.pickListNameMap.set("AM_Sex", "AM Animal Sex");
        this.pickListNameMap.set("AM_Endpoint", "AM Endpoint");
        this.pickListNameMap.set("AM_ModelStatus", "AM Model Status");

        // Manuscript Tracker
        this.pickListNameMap.set("MS_Status", "Manuscript Status");


        this.pickListGroupMap = [
            new PickListGroup("General", ["RevamppVersion", "RevamppStatus"]),
            new PickListGroup("Center/Core/Project", ["OrganizationalType", "CoreServices", "VaccinePlatforms", "AntibodyPlatforms", "Countermeasures"]),
            new PickListGroup("Virus", ["BSL", "ABSL", "AnimalModel", "VirusOrder", "VirusVector", "VirusHost", "VirusTarget"]),
            new PickListGroup("Location/Country", ["CountryRegion", "UsStates"]),
            new PickListGroup("Users", ["MemberRoles", "GroupCommittee", "GroupCommitteeRoles", "OrgInstitution", "TerminalDegree"]),
            new PickListGroup("Deliverables", ["DeliverableCategory", "TrlTag", "DeliverableSubcategoryVaccine", "DeliverableSubcategoryAntibody", "DeliverableSubcategoryKnowledge", "DeliverableSubcategoryCoordination", "DeliverableStageVaccine", "DeliverableStageAntibody", "DeliverableStageKnowledge", "DeliverableStageCoordination"]),
            new PickListGroup("Animal Models", ["AM_Purpose", "AM_ModelStatus", "AM_Route", "AM_Species", "AM_Strain", "AM_Source", "AM_Sex", "AM_Endpoint", "ABSL"]),
            new PickListGroup("Manuscripts", ["MS_Status"]),

        ];

        // set jquery items
        this.sectionContainer = $(`#${this.id}`);
        this.pickListGroupDropdown = this.sectionContainer.find("#pick-list-group-select");
        this.allPickListsDropdown = this.sectionContainer.find("#pick-list-select")
        this.selectedListTitle = this.sectionContainer.find("#selected-pick-list-title");
        this.selectedListOptionDropdown = this.sectionContainer.find("#selected-pick-list-options");

        this.buttonContainer = this.sectionContainer.find("#pick-list-button-container");
        this.addNewOptionBtn = this.sectionContainer.find("#add-new-pick-list-option-btn");
        this.editOptionBtn = this.sectionContainer.find("#edit-pick-list-option-btn");

        this.pickListOptionsTableContainer = this.sectionContainer.find("#pick-list-options-table-container");
        this.pickListOptionsTable = this.sectionContainer.find("#pick-list-table-collapse");

        this.pickListModal = $("#pick-list-modal");
        this.pickListModalTitle = this.pickListModal.find("#pick-list-modal-title");
        this.pickListFormSection = this.pickListModal.find("#pick-list-modal-form-section");

        this.initialize();
    }

    async initialize(isFirstLoad: boolean = true) {
        // Loading
        this.loadingDisplay(true);

        let result: any[] = await this.getPickLists();
        if (result) {
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>result);
        }

        let sortedResult: any[] = await this.getSortedPickLists();
        if (sortedResult) {
            this.sortedPickLists = plainToClass(JsonItem, <JsonItem[]>sortedResult);
        }

        // Dropdowns
        this.initializeDropdowns();
        if (isFirstLoad) {
            this.initialzeDropdownChange();
        }

        // Preselect Group Option if there is only 1
        let groupOptions = this.pickListGroupDropdown.find('option').toArray();
        if (groupOptions.length == 2) {
            let groupOption = groupOptions[1];
            this.pickListGroupDropdown.val(groupOption.value);
            this.pickListGroupDropdown.selectpicker("refresh");
        }

        // Show Content
        this.loadingDisplay(false);
    }

    async getPickLists() {
        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/list-management/list-management?handler=${this.getHandler}`,
                method: "GET",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    async getSortedPickLists() {
        if (this.getSortedHandler == "") {
            return [];
        }

        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/secure/list-management/list-management?handler=${this.getSortedHandler}`,
                method: "GET",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    loadingDisplay(isLoading: boolean): void {
        if (isLoading) {
            $("#loaded-content").addClass("d-none");
            $("#loading-content-container").removeClass("d-none");
        }
        else {
            $("#loading-content-container").addClass("d-none");
            $("#loaded-content").removeClass("d-none");
        }
    }

    initializeDropdowns(): void {
        // Pick List Groups
        let pickListGroupOptions: string[][] = [];
        for (let i = 0; i < this.pickListGroupMap.length; i++) {
            let displayValue = this.pickListGroupMap[i].groupName;
            let optionValue = this.pickListGroupMap[i].groupName;

            for (let j = 0; j < this.pickListGroupMap[i].associatedPickListNames.length; j++) {
                let pickListName = this.pickListGroupMap[i].associatedPickListNames[j];
                if (this.pickLists.some(list => list.Id == pickListName) || this.sortedPickLists.some(list => list.Id == pickListName)){
                    pickListGroupOptions.push([displayValue, optionValue]);
                    break;
                }
            }        
        }
        this.generateDropdown("pick-list-group-select", pickListGroupOptions);
        this.generateDropdown("pick-list-select", []);
        this.generateDropdown("selected-pick-list-options", []);
        // Set current dropdown if available
        if (this.currentPickListUpdate || this.currentSortedPickListUpdate) {
            this.pickListGroupDropdown.val(this.currentGroup).trigger("change");
            let pickListName = ""
            if (this.currentPickListUpdate?.pickListName) {
                pickListName = this.currentPickListUpdate.pickListName;
            }
            else if (this.currentSortedPickListUpdate?.pickListName) {
                pickListName = this.currentSortedPickListUpdate.pickListName;
            }

            if (pickListName != "") {
                this.allPickListsDropdown.val(pickListName).trigger("change");
            }
        } 
    }

    initialzeDropdownChange(): void {
        this.pickListGroupDropdown.on("changed.bs.select refreshed.bs.select", () => {
            let selectedVal: string = <string>this.pickListGroupDropdown.val();
            let foundGroup = this.pickListGroupMap.find(group => group.groupName == selectedVal);
            let pickListOptions: string[][] = [];
            if (foundGroup) {
                this.currentGroup = foundGroup.groupName;
                for (let i = 0; i < foundGroup.associatedPickListNames.length; i++) {
                    let pickListName = foundGroup.associatedPickListNames[i];
                    let displayName = pickListName;
                    if (this.pickListNameMap.has(pickListName)) {
                        displayName = this.pickListNameMap.get(pickListName);
                    }

                    if (this.pickLists.some(list => list.Id == pickListName) || this.sortedPickLists.some(list => list.Id == pickListName)) {
                        pickListOptions.push([displayName, pickListName]);
                    }
                }
            }
            this.generateDropdown("pick-list-select", pickListOptions);
        })

        this.allPickListsDropdown.on("changed.bs.select refreshed.bs.select", () => {
            this.pickListOptionsTable.empty();
            let selectedVal: string = <string>this.allPickListsDropdown.val();
            let foundList = this.pickLists.find(item => item.Id == selectedVal);
            let foundSortedList = this.sortedPickLists.find(item => item.Id == selectedVal);
            if (foundList) {
                this.currentPickListName = foundList.Id;
                this.currentSortOrder = 0;
                this.isCurrentSortList = false;
                let foundPickListDisplayName = this.pickListNameMap.get(foundList.Id);
                this.selectedListTitle.text(foundPickListDisplayName);
                let foundOptions: PickListItem[] = plainToClass(PickListItem, <PickListItem[]>foundList.Json);
                foundOptions.sort((x1: PickListItem, x2: PickListItem) => {
                    let option1: string = x1.Value;
                    let option2: string = x2.Value;
                    if (option1.startsWith("-") && !option2.startsWith("-")) {
                        return 1;
                    }
                    else if (option2.startsWith("-") && !option1.startsWith("-")) {
                        return -1;
                    }
                    else {
                        return option1.localeCompare(option2);
                    }
                })
                this.currentOptionsList = foundOptions;
                this.currentSortedOptionsList = [];
                let options: string[][] = [];
                let tableContent = "";
                foundOptions.forEach(option => {
                    options.push([option.Value, option.Id.toString()]);
                    tableContent += `<div class="pick-list-option-table-item" data-value="${option.Id}">${option.Value}</div>`
                });

                this.pickListOptionsTable.html(tableContent);
                this.generateDropdown("selected-pick-list-options", options);
                this.initializeOptionsTable();

                this.buttonContainer.removeClass("d-none");
                this.pickListOptionsTableContainer.removeClass("d-none");
            }
            else if (foundSortedList) {
                this.currentPickListName = foundSortedList.Id;
                this.isCurrentSortList = true;
                let foundPickListDisplayName = this.pickListNameMap.get(foundSortedList.Id);
                this.selectedListTitle.text(foundPickListDisplayName);
                let foundOptions: PickListItemSorted[] = plainToClass(PickListItemSorted, <PickListItemSorted[]>foundSortedList.Json);
                foundOptions.sort((x1: PickListItemSorted, x2: PickListItemSorted) => {
                    let option1: number = x1.SortOrder;
                    let option2: number = x2.SortOrder;
                    if (option1 <= option2) {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                })
                this.currentOptionsList = [];
                this.currentSortedOptionsList = foundOptions;
                let options: string[][] = [];
                let tableContent = "";
                foundOptions.forEach(option => {
                    options.push([option.Value, option.Id.toString()]);
                    tableContent += `<div class="pick-list-option-table-item" data-value="${option.Id}" data-sort="${option.SortOrder}"><span class="pr-3">${option.SortOrder.toString()}</span>${option.Value}</div>`
                });

                this.pickListOptionsTable.html(tableContent);
                this.generateDropdown("selected-pick-list-options", options, false);
                this.initializeOptionsTable();

                this.buttonContainer.removeClass("d-none");
                this.pickListOptionsTableContainer.removeClass("d-none");
            }
            else {
                this.selectedListTitle.text("Select a Pick List");
                this.currentPickListName = "";
                this.currentSortOrder = 0;
                this.isCurrentSortList = false;
                this.currentOptionsList = [];
                this.currentSortedOptionsList = [];
                this.generateDropdown("selected-pick-list-options", []);
                this.buttonContainer.addClass("d-none");
                this.pickListOptionsTableContainer.addClass("d-none");
            }
        });

        this.selectedListOptionDropdown.on("changed.bs.select refreshed.bs.select", () => {
            $(".pick-list-option-table-item").removeClass("active");
            let selectedVal = <string>this.selectedListOptionDropdown.val();
            if (selectedVal) {
                let valNum = parseInt(selectedVal);
                if (valNum) {
                    this.currentOptionId = valNum;
                    if (this.isCurrentSortList) {
                        let foundValue = this.currentSortedOptionsList.find(option => option.Id == valNum);
                        if (foundValue) {
                            this.currentOptionValue = foundValue.Value;
                            this.currentSortOrder = foundValue.SortOrder;
                            this.pickListOptionsTable.find(`[data-value="${this.currentOptionId}"]`).addClass("active");
                        }
                        else {
                            this.currentOptionValue = "";
                            this.currentSortOrder = 0;
                        }
                    }
                    else {
                        let foundValue = this.currentOptionsList.find(option => option.Id == valNum);
                        if (foundValue) {
                            this.currentOptionValue = foundValue.Value;
                            this.pickListOptionsTable.find(`[data-value="${this.currentOptionId}"]`).addClass("active");
                        }
                        else {
                            this.currentOptionValue = "";
                        }
                    }                      
                }
                else {
                    this.currentOptionId = 0;
                    this.currentSortOrder = 0;
                }
                this.editOptionBtn.removeClass("disabled");
            }
            else {
                this.editOptionBtn.addClass("disabled");
            }
        });
    }

    initializeOptionsTable(): void {
        $(".pick-list-option-table-item").off().on('click', (e) => {
            let optionId = $(e.currentTarget).data("value");
            $(".pick-list-option-table-item").removeClass("active");
            $(e.currentTarget).addClass("active");

            this.selectedListOptionDropdown.selectpicker("val", optionId.toString());
        })
    }

    generateDropdown(id: string, options: string[][], shouldSort: boolean = true): void {
        // Remove any previous options
        $(`#${id}`).find("option").remove();

        $(`#${id}`).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",
        });
        if (options != undefined) {
            if (shouldSort) {
                options.sort((x1: string[], x2: string[]) => {
                    if (x1[0].startsWith("-") && !x2[0].startsWith("-")) {
                        return 1;
                    }
                    else if (x2[0].startsWith("-") && !x1[0].startsWith("-")) {
                        return -1;
                    }
                    else {
                        return x1[0].localeCompare(x2[0]);
                    }
                });
            }          
            options.forEach((element: string[]) => {
                $(`#${id}`).append(new Option(element[0], element[1], false, false))
            })
        }

        $(`#${id}`).selectpicker("refresh");
    }

    openAddModal(): void {
        // Reset 
        this.currentPickListUpdate = undefined; 
        this.currentSortedPickListUpdate = undefined;

        // Set Title
        if (this.pickListNameMap.has(this.currentPickListName)) {
            this.pickListModalTitle.html(`Add Option: ${this.pickListNameMap.get(this.currentPickListName)}`);
        }
        else {
            return;
        }

        if (this.isCurrentSortList) {
            // CreateItem
            this.currentSortedPickListUpdate = new PickListSortedUpdate(this.currentPickListName, "", this.currentSortOrder);

            // Update Body
            this.pickListFormSection.empty().html(this.generateSortedModalHtml(this.currentSortedPickListUpdate));
        }
        else {
            // Create Item
            this.currentPickListUpdate = new PickListUpdate(this.currentPickListName, "");

            // Update Body
            this.pickListFormSection.empty().html(this.generateModalHtml(this.currentPickListUpdate));
        }    

        this.pickListModal.modal("show");
    }

    openEditModal(e: Event): void {
        if (!this.currentOptionId || !this.currentOptionValue) {
            return;
        }

        if ($(e.currentTarget).hasClass("disabled")) {
            return;
        }

        // Reset 
        this.currentPickListUpdate = undefined;
        this.currentSortedPickListUpdate = undefined;

        // Set Title
        if (this.pickListNameMap.has(this.currentPickListName)) {
            this.pickListModalTitle.html(`Add Option: ${this.pickListNameMap.get(this.currentPickListName)}`);
        }
        else {
            return;
        }

        if (this.isCurrentSortList) {
            // Create Item
            this.currentSortedPickListUpdate = new PickListSortedUpdate(this.currentPickListName, this.currentOptionValue, this.currentSortOrder, this.currentOptionId);

            // Update Body
            this.pickListFormSection.empty().html(this.generateSortedModalHtml(this.currentSortedPickListUpdate));
        }
        else {
            // Create Item
            this.currentPickListUpdate = new PickListUpdate(this.currentPickListName, this.currentOptionValue, this.currentOptionId);

            // Update Body
            this.pickListFormSection.empty().html(this.generateModalHtml(this.currentPickListUpdate));
        }      

        this.pickListModal.modal("show");
    }

    generateModalHtml(pickListUpdate: PickListUpdate): string {
        let content = "";
        if (pickListUpdate.optionId != 0) {
            content += `
            <div class="mb-3">
                <label>Current Option Value</label>
                <p>${pickListUpdate.optionValue}</p>
            </div>
            `
        }

        content += `
        <div class="form-group">
            <label class="required">New Option Value</label>
            <input type="text" class="form-control col-lg-5 col-12 font-size14" id="pick-list-modal-option-input" value="${pickListUpdate.optionValue}">
        </div>
        `

        content += `
        <div id="pick-list-modal-error-display" class="d-none">
            <p id="error-helper-text">Error!</p>
        </div>
        `
        return content;
    }

    generateSortedModalHtml(pickListUpdate: PickListSortedUpdate): string {
        let content = "";
        if (pickListUpdate.optionId != 0) {
            content += `
            <div class="row mb-3">
                <div class="col-auto mr-3">
                    <label>Current Option Value</label>
                    <p>${pickListUpdate.optionValue}</p>
                
                </div>
                <div class="col-auto">
                    <label>Current Sort Order</label>
                    <p>${pickListUpdate.sortOrder.toString()}</p>
                </div>
            </div>
            `
        }

        content += `
        <div class="row">
            <div class="form-group col-lg-5 col-12">
                <label class="required">New Option Value</label>
                <input type="text" class="form-control col-12 font-size14" id="pick-list-modal-option-input" value="${pickListUpdate.optionValue}">
            </div>
            <div class="form-group col-lg-3 col-12">
                <label class="required">New Sort Order</label>
                <input type="number" class="form-control col-12 font-size14" id="pick-list-modal-option-sort-input" min="0" step="1" value="${pickListUpdate.sortOrder}">
            </div>
        </div>   
        `

        content += `
        <div id="pick-list-modal-error-display" class="d-none">
            <p id="error-helper-text">Error!</p>
        </div>
        `
        return content;
    }

    async save() {

        let isValid: boolean = false;
        if (this.isCurrentSortList) {
            isValid = this.validateFormSorted();
        }
        else {
            isValid = this.validateForm();
        }

        if (isValid) {
            // Ajax request
            this.showSaving(true);
            if (this.isCurrentSortList) {
                this.currentSortedPickListUpdate.optionValue = <string>$("#pick-list-modal-option-input").val();
                let foundSortOrder: number = <number>$("#pick-list-modal-option-sort-input").val()
                this.currentSortedPickListUpdate.sortOrder = parseInt(foundSortOrder.toString());
                let response = await this.saveToDB(true);
            }
            else {
                this.currentPickListUpdate.optionValue = <string>$("#pick-list-modal-option-input").val();
                let response = await this.saveToDB();
            }   

            await this.initialize(false);
            this.showSaved(true);

            setTimeout(() => {
                this.pickListModal.modal("hide");

                setTimeout(() => {
                    this.showSaved(false);
                    this.showSaving(false);
                }, 1000)
            }, 1000)
        }
        else {
            return;
        }
    }

    async saveToDB(isSorted: boolean = false): Promise<any> {
        let result: Promise<any>;
        if (isSorted) {
            try {
                result = await $.ajax({
                    url: `/secure/list-management/list-management?handler=${this.postSortedHandler}`,
                    method: "POST",
                    data: { data: JSON.stringify(this.currentSortedPickListUpdate) },
                    headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                })
                return result;
            }
            catch (error) {
                alert("An error has occurred, please refresh the page and try again.");
                console.log(error);
            }
        }
        else {
            try {
                result = await $.ajax({
                    url: `/secure/list-management/list-management?handler=${this.postHandler}`,
                    method: "POST",
                    data: { data: JSON.stringify(this.currentPickListUpdate) },
                    headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                })
                return result;
            }
            catch (error) {
                alert("An error has occurred, please refresh the page and try again.");
                console.log(error);
            }
        }
        
    }


    showSaving(isSaving: boolean) {
        if (isSaving) {
            this.showSaved(false);
            $("#pick-list-modal-content").addClass("d-none");
            $("#pick-list-saving").removeClass("d-none");
        }
        else {
            $("#pick-list-modal-content").removeClass("d-none");
            $("#pick-list-saving").addClass("d-none");
        }
    }

    showSaved(isSaved: boolean) {
        if (isSaved) {
            $("#pl-save-in-progress-block").addClass("d-none");
            $("#pl-save-complete-block").removeClass("d-none");
        }
        else {
            $("#pl-save-in-progress-block").removeClass("d-none");
            $("#pl-save-complete-block").addClass("d-none");
        }
    }

    validateForm(): boolean {
        let newOption = <string>$("#pick-list-modal-option-input").val();
        let isValid = true;
        let errorText = "";


        // Need to validate that there is a value for the new option
        if (newOption == "") {
            isValid = false;
            errorText = "Please enter a new option name."
        }

        // Need to validate that the new value does not already exist
        let pickListOptionValues = this.currentOptionsList.map(option => option.Value);
        if (pickListOptionValues.includes(newOption)) {
            isValid = false;
            errorText = "This option name already exists. Please enter a new option name."
        }
        // Add valid classes, and add helper-text
        $("#error-helper-text").text(errorText);
        if (!isValid) {
            $("#pick-list-modal-error-display").removeClass("d-none");
            $("#pick-list-modal-option-input").addClass("is-invalid")
        }
        else {
            $("#pick-list-modal-error-display").addClass("d-none");
            $("#pick-list-modal-option-input").removeClass("is-invalid")
        }
        return isValid;
    }

    validateFormSorted(): boolean {
        let newOption = <string>$("#pick-list-modal-option-input").val();
        let newSortOrderStr = <string>$("#pick-list-modal-option-sort-input").val();
        let newSortOrder = parseInt(newSortOrderStr);
        let isValid = true;
        let errorText = "";
        let pickListOptionValues = this.currentSortedOptionsList.map(option => option.Value);
        let sortOrderOptions = this.currentSortedOptionsList.map(option => option.SortOrder);

        // Refresh Validation
        $("#pick-list-modal-option-input").removeClass("is-invalid");
        $("#pick-list-modal-option-sort-input").removeClass("is-invalid");

        // Validation for Sort order number
        if (!newSortOrder) {
            isValid = false;
            errorText = "Please enter a valid Sort Order. It must be a whole number (integer)."
            $("#pick-list-modal-option-sort-input").addClass("is-invalid");
        }

        // No Change
        else if (newOption.trim() == this.currentSortedPickListUpdate.optionValue && newSortOrder == this.currentSortedPickListUpdate.sortOrder) {
            isValid = false;
            errorText = "Please change either the Option Value or the Sort Order.";
            $("#pick-list-modal-option-sort-input").addClass("is-invalid");
            $("#pick-list-modal-option-input").addClass("is-invalid");
        }

        // Sort Order
        else if (newSortOrder <= 0) {
            isValid = false;
            errorText = "Please enter a Sort Order larger than 0."
            $("#pick-list-modal-option-sort-input").addClass("is-invalid");
        }     

        // Option Value
        else if (newOption.trim() == "") {
            isValid = false;
            errorText = "Please enter an Option Value."
            $("#pick-list-modal-option-input").addClass("is-invalid");
        }

        // New Option Value Matches Existing Option       
        else if (pickListOptionValues.includes(newOption.trim()) && newOption.trim() != this.currentSortedPickListUpdate.optionValue) {
            isValid = false;
            errorText = "This option name already exists. Please enter a new option name."
            $("#pick-list-modal-option-input").addClass("is-invalid");
        }

        // New Sort Order Matches Existing Option   
        else if (sortOrderOptions.includes(newSortOrder) && newSortOrder != this.currentSortedPickListUpdate.sortOrder) {
            isValid = false;
            errorText = "Another option already has this Sort Order."
            $("#pick-list-modal-option-sort-input").addClass("is-invalid");
        }

        $("#error-helper-text").text(errorText);
        if (!isValid) {
            $("#pick-list-modal-error-display").removeClass("d-none");
        }
        else {
            $("#pick-list-modal-error-display").addClass("d-none");
            $("#pick-list-modal-option-input").removeClass("is-invalid");
            $("#pick-list-modal-option-sort-input").removeClass("is-invalid");
        }

        return isValid;
    }
}

class PickListUpdate {
    pickListName: string;
    optionId: number;
    optionValue: string;

    constructor(pickListName: string, optionValue: string, optionId: number = 0) {
        this.pickListName = pickListName;
        this.optionValue = optionValue;
        this.optionId = optionId;
    }
}

class PickListSortedUpdate {
    pickListName: string;
    optionId: number;
    optionValue: string;
    sortOrder: number;

    constructor(pickListName: string, optionValue: string, sortOrder: number, optionId: number = 0) {
        this.pickListName = pickListName;
        this.optionValue = optionValue;
        this.optionId = optionId;
        this.sortOrder = sortOrder;
    }
}

class PickListGroup {
    groupName: string;
    associatedPickListNames: string[];
    constructor(groupName: string, associatedPickLists: string[]) {
        this.groupName = groupName;
        this.associatedPickListNames = associatedPickLists;
    }
}